require( './bootstrap' );
// add lazy-load supported
import LazyLoad from "vanilla-lazyload";
let myLazyLoad = new LazyLoad();

document.addEventListener(
    'DOMContentLoaded',
    function () {
        let myLazyLoad = new LazyLoad( {
            elements_selector: ".lazy-load"
        } );
    }
);

import './loadmore'
/*HELPERS*/
function addClass(el, className) {
    if (el.classList) {
        el.classList.add(className);
        el.childNodes[0].src = '/wp-content/themes/6084/img/prod/' + el.dataset.sort + '_hover.svg';
    } else {
        el.className += ' ' + className;
    }

} function removeClass(el, className) {
    if (el.classList) {
        el.childNodes[0].src = '/wp-content/themes/6084/img/prod/' + el.dataset.sort + '.svg';
        el.classList.remove(className);
    }
    else
        el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
} function hasClass(el, className) {
    let result = false;
    if (el.classList) {
        if (el.classList.contains(className)) result = true;
    } else {
        if (new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className)) result = true;
    } return result;
}

(function () {
    'use strict';
    //--------------------------------------------------------------------------------------------------------------
    //	LOAD IFRAME GAME
    //--------------------------------------------------------------------------------------------------------------
    (function () {
        let wrap = document.getElementById('js_game');
        if (wrap) {
            loadGame();
        }

        function loadGame() {
            let btn = wrap.getElementsByTagName('button')[0];
            if (btn) {
                btn.addEventListener('click', loadFrame);
            }

            function loadFrame() {
                let frame = document.createElement('iframe'),
                    src = wrap.getAttribute('data-game');

                frame.setAttribute('src', src);
                btn.removeEventListener('click', loadFrame);
                wrap.innerHTML = '';
                wrap.appendChild(frame);
            }
        }
    })();
})();

document.addEventListener("DOMContentLoaded", (event) => {
    // BURGER MENU CLICK
    let burger = document.querySelector('.nav-menu-burger .top-menu');
    if ( burger ) {
        burger.addEventListener('click', () => {
            let menu = document.querySelector('.header-top-menu-mj');
            if (menu) {
                if (menu.classList.contains('slideDownAnim')) {
                    menu.classList.remove('slideDownAnim');
                } else {
                    menu.classList.add('slideDownAnim');
                }
            }
        });
    }


    let tocSubMenus = document.querySelectorAll('.content-text nav > ul > li > ul');
    if (tocSubMenus.length) {
        tocSubMenus.forEach(subMenu => {
            let subMenuArrow = document.createElement('button');
            subMenuArrow.classList.add('sub-menu-arrow');
            subMenu.before(subMenuArrow);

            subMenuArrow.addEventListener('click', (event) => {
                event.preventDefault();
                let self = event.currentTarget;
                let subMenuHeight = subMenu.scrollHeight + 'px';
                if ( self.classList.contains('active') ) {
                    self.classList.remove('active');
                    subMenu.style.height = '0px';
                } else {
                    self.classList.add('active');
                    subMenu.style.height = subMenuHeight;
                }
            });
        });
    }

    // SCROLL TO TOP JS
    (function() {
        let body = document.body,
            up_button = document.querySelector('.js_up_btn');

        if (up_button){
            window.onscroll = function() {
                let scrolled = window.pageYOffset || document.documentElement.scrollTop,
                    h = window.innerHeight;
                if (scrolled > 0.5*h) {
                    up_button.classList.add('active');
                    up_button.addEventListener('click', scrollToTop);
                }
                else {
                    up_button.classList.remove('active');
                    up_button.removeEventListener('click', scrollToTop);
                }
            };
        }

        function scrollToTop() {
            let start = Date.now();
            let timer = setInterval(function() {
                let timePassed = Date.now() - start;
                let time = 5000;
                let scrolled = window.pageYOffset || document.documentElement.scrollTop;
                if (timePassed >= time || scrolled <= 0) {
                    clearInterval(timer);
                    return;
                }
                up (timePassed,time,scrolled);
            }, 10);

            function up(timePassed,time,scrolled) {
                if (scrolled > 0) {
                    let x = scrolled - (scrolled*timePassed/(2*time));
                    window.scrollTo(0,x);
                }
            }
        }
    })();



    // Slots filter on front page
    let filterBlock = document.querySelector('.slots-filter');
    if (filterBlock) {
        let filters   = filterBlock.querySelectorAll('.js-slots-filter-item');
        let slotsWrap = document.querySelector('.slots-wrap');
        let slots     = slotsWrap.querySelectorAll('.slot');
        filters.forEach(filter => {
            filter.addEventListener('click', event => {
                let self = event.currentTarget;

                // Enable filter
                if (self.classList.contains('active')) {
                    self.classList.remove('active');
                } else {
                    self.classList.add('active');
                }

                // Get all active filters
                let activeFilterItems = filterBlock.querySelectorAll('.js-slots-filter-item.active');

                // If choose all slot
                if ( self.getAttribute('data-filter-type') === 'all' ) {
                    for (let i = 0; i < slots.length; i++) {
                        slots[i].removeAttribute('hidden');
                    }
                    for (let i = 0; i < activeFilterItems.length; i++) {
                        activeFilterItems[i].classList.remove('active');
                    }
                    self.classList.remove('active');
                    return;
                }

                let activeThemeFilters = [];
                let activeSumFilters = [];
                for (let i = 0; i < activeFilterItems.length; i++) {
                    if ( activeFilterItems[i].getAttribute('data-filter-type') === 'all' ) {
                        activeFilterItems[i].classList.remove('active');
                    } else if ( activeFilterItems[i].getAttribute('data-filter-type') === 'theme' ) {
                        activeThemeFilters.push(activeFilterItems[i].getAttribute('data-filter'));
                    } else {
                        activeSumFilters.push(activeFilterItems[i].getAttribute('data-filter'));
                    }
                }

                for (let i = 0; i < slots.length; i++) {
                    let themeFilter = slots[i].getAttribute('data-filter-theme');
                    let sumFilter   = slots[i].getAttribute('data-filter-sum');
                    let hiddenTheme = false;
                    let hiddenSum   = false;
                    if (activeThemeFilters.length) {
                        if ( !(themeFilter && activeThemeFilters.indexOf(themeFilter) !== -1) ) {
                            hiddenTheme = true;
                        }
                    }
                    if (activeSumFilters.length) {
                        if ( !(sumFilter && activeSumFilters.indexOf(sumFilter) !== -1) ) {
                            hiddenSum = true;
                        }
                    }

                    if (hiddenSum || hiddenTheme) {
                        slots[i].setAttribute('hidden', '');
                    } else {
                        slots[i].removeAttribute('hidden');
                    }
                }
            });
        });
    }
});
